var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descriptionOfGoods"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.ReportsDetail.BULK_SUMMARY'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Packed')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.packed,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Unpacked')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.unpacked,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Semi_finished')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.semi,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Sambox')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.sampboxphoto,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Samproduct')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.sampproductphoto,"otherData":{
          mediaName: '',
          mediaType: '',
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: '',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-table"},[_c('a-table',{staticClass:"desOfGoods-table1",attrs:{"columns":_vm.columns,"dataSource":_vm.data,"bordered":"","pagination":false,"rowKey":"id"}},[_c('template',{slot:"footer"},[_c('p',{staticClass:"footer1"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.ReportsDetail.Remarks')))]),(_vm.data == undefined)?_c('span'):(_vm.data.length == 0)?_c('span'):_c('span',[_vm._v(_vm._s(_vm.data[0].goodsRemark))])])])],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }